<template>
  <div class="navget_main">
    <img
      :src="
        goImg
          ? themeStyleVs === 2
            ? blockClose
            : closeImg
          : themeStyleVs === 2
          ? blockBackImg
          : backImg
      "
      @click="goBack"
    />{{ text }}
    <img
      v-if="shareImgShow && compareVersions( version , 9.68)"
      class="share_btn_box"
      :src="themeStyleVs === 2 ? blackShare : shareBtn"
      @click="shareFn"
      alt=""
    />
  </div>
</template>
<script>
import { compareVersions } from '@/utils/format';
import mixins from '@/mixins/index.js';
export default {
  name: 'navigation',
  mixins: [mixins],
  props: {
    text: {
      type: String,
      required: true
    },
    searchShow: {
      type: Boolean,
      required: true
    },
    shareImgShow: {
      default: false
    }
  },
  data() {
    return {
      backImg: require('../assets/image/left.png'),
      blockBackImg: require('../assets/image/blockImg/left.png'),
      searchImg: require('../assets/image/search.png'),
      closeImg: require('../assets/image/close_btn.png'),
      blockClose: require('../assets/image/blockImg/close.png'),

      shareBtn: require('../assets/image/share_btn.png'),
      blackShare: require('../assets/image/blockImg/share_img.png'),
      sourceType: 'false',
      goImg: false,
      themeStyleVs: 1,
      shareType: 'false',
      version: 0,
      source: ''
    };
  },
  filters: {},
  created() {
    this.themeStyleVs = Number(this.getUrlQuery('themeStyleVs'));
    this.shareType = this.getUrlQuery('shareType');
    this.version = Number(this.getUrlQuery('version'));
    this.source = this.getUrlQuery('source');
  },
  mounted() {
    this.goImg = this.$route.name === 'My' || this.shareType == 'true' ? true : false;
    this.sourceType = this.getUrlQuery('sourceType') ? this.getUrlQuery('sourceType') : 'false';
  },
  methods: {
    compareVersions,
    goBack: function () {
      if (this.source == 'appLhHc') {
        this.$router.go(-1);
        return false;
      }
      if (this.shareType == 'true') {
        location.href = 'dzh_browser_url&goto=0&screen=263';
      } else {
        if (this.sourceType === 'true') {
          this.$router.go(-1);
        } else {
          if (typeof DzhAppJs == 'undefined') {
            window.close();
          } else {
            location.href = 'dzh_browser_url&goto=0&screen=263';
          }
        }
      }
    },
    shareFn: function () {
      this.$emit('shareBtn');
    }
  }
};
</script>
<style lang="less" scoped>
.navget_main {
  width: 100%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #373a4d;
  position: relative;
  img {
    &:first-child {
      width: 24px;
      height: 24px;
      position: absolute;
      top: 10px;
      left: 16px;
    }
    &:last-child {
      width: 24px;
      height: 24px;
      position: absolute;
      top: 11px;
      right: 16px;
    }
  }
}
</style>
